import { BRAND_GLYPHS } from '@/lib/brand-glyphs';
import { AI_SURFACES, type AiSurface } from '@/lib/content';
import { cn } from '@/lib/utils';

/** Each assistant's own plate colour. The glyph itself is shared — see `lib/brand-glyphs`. */
const PLATE: Record<AiSurface, string> = {
  ChatGPT: '#000000',
  Claude: '#D97757',
  Gemini: '#1A73E8',
  Perplexity: '#20808D',
};

export function AiMark({ surface }: { surface: AiSurface }) {
  const background = PLATE[surface];
  const path = BRAND_GLYPHS[surface];
  return (
    <span
      style={{ background }}
      className="inline-flex size-4 shrink-0 items-center justify-center rounded-[4px] shadow-[inset_0_0_0_1px_rgb(255_255_255/0.22)]"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true" className="size-[11px] fill-white">
        <path d={path} />
      </svg>
    </span>
  );
}

/** The full set of assistants, as one labelled unit rather than four unnamed swatches. */
export function AiMarkRow({
  className,
  entrance,
}: {
  className?: string;
  /** Deal the marks in one at a time from `delayMs`, `stepMs` apart. Omit for a static row. */
  entrance?: { delayMs: number; stepMs: number; playing: boolean };
}) {
  return (
    <span
      role="img"
      aria-label={AI_SURFACES.join(', ')}
      className={cn('inline-flex gap-1', className)}
    >
      {AI_SURFACES.map((surface, index) => (
        <span
          key={surface}
          style={
            entrance && {
              animationDelay: `${entrance.delayMs + index * entrance.stepMs}ms`,
              animationPlayState: entrance.playing ? 'running' : 'paused',
            }
          }
          className={cn('inline-flex', entrance && 'animate-fade-in motion-reduce:animate-none')}
        >
          <AiMark surface={surface} />
        </span>
      ))}
    </span>
  );
}
